export default __webpack_public_path__ + "static/media/loading.0795de46.gif";